export enum V6FrameType {
  RESOURCE_FRAME = 0,
  NESTED_FRAME = 1,
}
export enum V6ProductCreationStep {
  GENERAL_CONFIG = 0,
  MANAGE_FRAME = 1,
  CONFIGURE_FRAME = 2,
}
export enum V6FrameConfigMode {
  ADD_RESOURCE_FRAME = 0,
  EDIT_RESOURCE_FRAME = 1,
  ADD_NESTED_FRAME = 2,
  EDIT_NESTED_FRAME = 3,
}
export enum ProductConfigStep {
  BASE_CONFIG = 0,
  CONFIG_DETAILS = 1,
  CONFIRM_CONFIG = 2,
}
export enum V6ProductType {
  CONFIGURED = 1,
  KWIK_KEY_DOOR = 2,
  KWIK_KEY_FRAME = 3,
  DRAFT = 4,
}
export enum KwikKeyConfigType {
  NONE=0,
  DOOR_ONLY = 1,
  DOOR_AND_FRAME = 2,
  FRAME_ONLY = 3,
  FRAME_AND_DOOR=4
}
export enum ProductConfigOpsType {
  ADD = 1,
  EDIT = 2,
  COPY = 3
}
export enum V6OptionValueType {
  LIST = 'List',
  RADIO = 'Radio',
  STRING = 'String',
  DOUBLE = 'Double',
  BOOLEAN = 'Boolean',
}

export enum V6ConfigurationActioType {
  ADMIN_PREVIEW = 'ADMIN_PREVIEW',
  USER_PRODUCT_CREATION = 'USER_PRODUCT_CREATION',
}

export enum V6FrameConfigType {
  SBVMORT = 'SBVMORT',
  OTHER = 'OTHER',
}
